import React, {useContext, useCallback, useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {labels, GetCardTypeForBody} from '../../../../../util/utils';
import {body} from '../../shapes';
import BodyKnowledgeDescription from '../BodyKnowledgeDescription';
import {DocumentTypeIdContext} from '../../../../Main/Forms/CanvasFormContainer';
import {createRequestURL, createUpdatePayload} from '../Common/BodyResponseUtility';
import CanvasFormInput from '../../CanvasFormInput';
import CanvasFormInputValue from '../../CanvasFormInputValue';
import {FormBodyChangesContext} from '../FormBodyChangesWatcher';
import {useDocumentId, useEngagementId} from '../../../../../util/customHooks';

export default function PACEInputBody({
	options,
	headerId,
	sectionId,
	guidanceFilter,
	bodyId,
	updateBodyOptions,
	getBodiesBySectionId,
	isSnapshotView,
	showGuidance
}) {
	const engagementId = useEngagementId(),
		documentId = useDocumentId(),
		documentTypeId = useContext(DocumentTypeIdContext),
		{onBodyValueChanged, resetChanges} = useContext(FormBodyChangesContext);
	const elementName = `${headerId}-${sectionId}-${bodyId}`;

	const initialValue = options.bodyFreeText;

	// This is necessary because options.bodyFreetext value does not change after successful update!
	const [value, setValue] = useState(initialValue);

	const saveInputEdit = useCallback(
		(value) => {
			return updateBodyOptions(
				bodyId,
				0,
				createRequestURL(engagementId, documentId, headerId, sectionId, bodyId, documentTypeId),
				createUpdatePayload(options?.bodyTypeId, value)
			).then(() => {
				resetChanges(bodyId, elementName);
				setValue(value);
			});
		},
		[engagementId, documentId, documentTypeId]
	);

	const formBodyBorder = GetCardTypeForBody(options);

	const handleOnCancel = () => {
		resetChanges(bodyId, elementName);
	};

	const handleOnChange = (value) => {
		onBodyValueChanged(bodyId, initialValue, value, elementName);
	};

	useEffect(() => {
		setValue(initialValue);
	}, [initialValue]);

	const isDisplayBlock = value && value?.length - 54 > 50;

	return (
		<StyledPACEInputBody className={`SectionBodyWrapper ${formBodyBorder}`}>
			{options && (
				<BodyKnowledgeDescription
					guidanceFilter={guidanceFilter}
					isSnapshotView={isSnapshotView}
					bodyModel={options}
					engagementId={engagementId}
					documentId={documentId}
					headerId={headerId}
					sectionId={sectionId}
					bodyId={bodyId}
					bodyDescriptionText={options.name}
					isCustom={options.isCustom}
					isDuplicate={options.isDuplicate}
					getBodiesBySectionId={getBodiesBySectionId}
					showGuidance={showGuidance}
				/>
			)}
			<section
				className={`SectionBodyData PaceInputBodyData ${
					isDisplayBlock ? 'PaceInputBodyDataBlock' : ''
				} ${formBodyBorder}`}
				id={bodyId}
			>
				<CanvasFormInput
					className="pace-input-body-progress-bar-input"
					value={value}
					label={labels.paceInputPlaceholder}
					placeholderText={labels.paceInputPlaceholder}
					pattern="^\d{1,50}(\.+\d{0,50})*$"
					onCancel={handleOnCancel}
					onChange={handleOnChange}
					onAccept={saveInputEdit}
					maxLength={51}
					isReadOnly={isSnapshotView}
					id={value}
				>
					<CanvasFormInputValue isSnapshotView={isSnapshotView} />
				</CanvasFormInput>
			</section>
		</StyledPACEInputBody>
	);
}

PACEInputBody.propTypes = {
	options: PropTypes.shape(body),
	headerId: PropTypes.number.isRequired,
	sectionId: PropTypes.number.isRequired,
	bodyId: PropTypes.number.isRequired,
	updateBodyOptions: PropTypes.func.isRequired,
	getBodiesBySectionId: PropTypes.func.isRequired,
	isSnapshotView: PropTypes.bool,
	numberFormat: PropTypes.string
};

PACEInputBody.defaultProps = {
	isSnapshotView: false
};

const StyledPACEInputBody = styled.section`
	.pace-input-body-progress-bar-input {
		width: var(--px-450);
		.motif-form-field {
			width: 100% !important;
		}
	}
	.PaceInputBodyDataBlock {
		.pace-input-body-progress-bar-input {
			.motif-form-field {
				height: 100% !important;
				.canvas-form-input-display-value {
					padding-top: var(--px-10);
				}
				.StyledCanvasFormInputValue {
					display: inline-block;
					padding-top: var(--px-5);
					.RichTextBodySpan {
						.diffdel {
							display: block;
						}
						p {
							margin-block-start: 0;
							margin-block-end: 0;
						}
					}
				}
			}
		}
	}
`;
